import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FnNoDataBoxComponent } from './fn-no-data-box.component';
import { CommonModule } from '@angular/common';

export * from './fn-no-data-box.component';

/**
 * Exports the required FnButtonComponent to create button field
 * making them available for import by NgModules that import this module.
 */

@NgModule({
	imports: [CommonModule],
	exports: [FnNoDataBoxComponent],
	declarations: [FnNoDataBoxComponent],
	providers: [],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FnNoDataBoxModule {}
